// クエリを扱うサービスです。
// TODO ちょっと汚くなってきているのでリファクタリングする

import Vue from 'vue'
import { isArray } from 'lodash'
import repository from '@/repositories/Repository'
import store from '@/store'

// 各コンポーネントからアクセスするときの名前登録（テンプレ）
Vue.mixin({
  beforeCreate() {
    const options = this.$options
    if (options.longQuery) this.$longQuery = options.longQuery
    else if (options.parent && options.parent.$longQuery)
      this.$longQuery = options.parent.$longQuery
  },
})

const storage = sessionStorage
const lastingStorage = localStorage

async function getSavedUserId() {
  return store.state.account.userId
}

export default {
  /**
   * リソース（メニュー）毎の分析条件を保存する
   */
  async saveMenuQueryFilter(resourceName, queryFilter) {
    const userId = await getSavedUserId()
    lastingStorage.setItem(
      `giggle.queryfilter.${resourceName}.${userId}.latest`,
      JSON.stringify(queryFilter),
    )
    return Promise.resolve(undefined)
  },
  /**
   * リソース（メニュー）毎の分析条件を取得する
   */
  async fetchMenuQueryFilter(menuCode) {
    const userId = await getSavedUserId()
    let queryFilter = lastingStorage.getItem(
      `giggle.queryfilter.${menuCode}.${userId}.latest`,
    )

    // 顧客グループコードは削除されている可能性があるので復元しない
    if (queryFilter) {
      queryFilter = JSON.parse(queryFilter)
      if (queryFilter.customer) {
        queryFilter.customer.customerGroupId = undefined
      }

      return Promise.resolve(queryFilter)
    } else {
      return Promise.resolve(undefined)
    }
  },
  /**
   * リソース（メニュー）毎の分析条件を削除する
   */
  async deleteMenuQueryFilter(menuCode) {
    const userId = await getSavedUserId()
    return new Promise(r => {
      lastingStorage.removeItem(
        `giggle.queryfilter.${menuCode}.${userId}.latest`,
      )
      r()
    })
  },
  /**
   * TODO APIを実装するとクエリフィルタ保存という処理は必要なくなる？
   */
  saveQueryFilter(queryId, queryFilter) {
    return new Promise(r => {
      storage.setItem(
        `giggle.queryfilter.${queryId}`,
        JSON.stringify(queryFilter),
      )

      r(queryId)
    })
  },
  /**
   * TODO 現状ローカルストレージに入れているデータを取得しているが、API化すると捗りそう
   */
  fetchQueryFilter(queryFilterId) {
    return new Promise(r => {
      r(JSON.parse(storage.getItem(`giggle.queryfilter.${queryFilterId}`)))
    })
  },
  /**
   * クエリを実行する
   *
   * 送信データにフォーマット不正等がなければ受付完了として即時レスポンスがあります。
   *
   * TODO フォーマット不正でエラーとなった場合の対処。
   */
  async executeQuery(resourceName, postData) {
    const response = await repository.http.post(
      `/api/${resourceName}`,
      postData,
    )
    return response.data
  },
  /**
   * クエリの詳細を取得する
   *
   * クエリ結果（データ）の参照ではないので注意
   */
  async fetchQueryInfo(_, queryId) {
    const response = await repository.http.get(`/api/query/${queryId}`)
    return response.data
  },
  /**
   * クエリ結果を取得するURL構築する
   *
   * * resourceName = pudding-s
   * * queryId = 6751b472c25
   * * option（Optional） = summary
   *
   * => 「/api/pudding-s/6751b472c25/fetch/summary」
   *
   * TODO 以前はトークンを取得したりするのでasyncにしていたと思うのですが、
   *      もう不要。
   */
  async getQueryResultFetchUrl(resourceName, queryId, option) {
    return `${
      process.env.VUE_APP_TMP_TAPIR_API_URL_BASE
    }/api/${resourceName}/${queryId}/fetch${option ? '/' + option : ''}`
  },
  /**
   * ColModelを取得するURLを構築する
   *
   * **結果の表が複数あるなどでQueryInfoにグリッド定義が取得できない画面用
   * に作成した関数です。通常の画面では使用する必要はありません。**
   */
  getColModelFetchUrl(resourceName, queryId, option) {
    return `${
      process.env.VUE_APP_TMP_TAPIR_API_URL_BASE
    }/api/${resourceName}/${queryId}/columns${option ? '/' + option : ''}`
  },
  /**
   * エクセル出力URL構築する
   */
  getExcelUrl(resourceName, queryId, extraProps) {
    const queryParam = Object.entries(extraProps)
      .map(([k, v]) => {
        if (isArray(v)) {
          return v.map(e => `${k}=${e}`).join('&')
        }
        return `${k}=${v}`
      })
      .join('&')

    return repository.http
      .get(`/api/${resourceName}/${queryId}/excel?${queryParam}`)
      .then(r => r.data)
  },
}
